export class FamilyType {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default FamilyType;